import React from 'react'

const SkeletonLoader = () => {
    return (
        <li className='skeleton-item'><a href='./'>a</a></li>
    )
}

export default SkeletonLoader